import React from "react"
import { Button, DialogActions, BackIcon } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

type CaseRateRenewalModalButtonGroupProps = {
  buttonOne: React.ReactElement
  buttonTwo: React.ReactElement
  back?: () => void
  disableBack?: boolean
}

export function CaseRateRenewalModalButtonGroup({
  buttonOne,
  buttonTwo,
  back,
  disableBack
}: CaseRateRenewalModalButtonGroupProps): JSX.Element {
  return (
    <DialogActions>
      {back && (
        <Button
          sx={{ marginInlineEnd: "auto" }}
          disabled={disableBack}
          variant="text"
          color="secondary"
          onClick={back}
          startIcon={<BackIcon />}
        >
          <FormattedMessage defaultMessage="Back" />
        </Button>
      )}

      {buttonOne}

      {buttonTwo}
    </DialogActions>
  )
}
